(function() {
  var initialized = false;

  function forceShowSizeBoxes() {
    if (initialized) return;
    
    var popovers = document.querySelectorAll('.ProductForm__Option [id^="popover-"]');
    if (popovers.length === 0) return;

    initialized = true;
    observer.disconnect();

    document.querySelectorAll('.ProductForm__Item').forEach(function(btn) {
      btn.style.cssText = 'display:none !important';
    });

    popovers.forEach(function(el) {
      el.removeAttribute('aria-hidden');
      el.style.cssText = 'display:block !important;visibility:visible !important;opacity:1 !important;height:auto !important;max-height:none !important;overflow:visible !important;position:static !important;transform:none !important;box-shadow:none !important;border:none !important;background:none !important;pointer-events:auto !important;';
    });

    document.querySelectorAll('.Popover__Header').forEach(function(el) {
      el.style.cssText = 'display:none !important';
    });
  }

  var observer = new MutationObserver(forceShowSizeBoxes);

  window.addEventListener('load', function() {
    forceShowSizeBoxes();
    if (!initialized) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  });
})();

(function() {
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.SizeBox');
    if (!btn) return;

    var list = btn.closest('.SizeBoxList');
    list.querySelectorAll('.SizeBox').forEach(function(b) {
      b.classList.remove('is-selected');
    });
    btn.classList.add('is-selected');

    var optionPosition = btn.getAttribute('data-option-position');
    var value = btn.getAttribute('data-value');

    var productJson = document.querySelector('[data-product-json]');
    if (!productJson) return;
    var data = JSON.parse(productJson.textContent);
    var variants = data.product.variants;

    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      if (v['option' + optionPosition] === value) {
        var input = document.querySelector('[name="id"]');
        if (input) {
          input.value = v.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
        break;
      }
    }
  });
})();
window.addEventListener('load', function() {
  setTimeout(function() {
    document.querySelectorAll('.Product__Gallery a[href*=".webp"]').forEach(function(a) {
      a.href = a.href.replace('.webp', '.jpg');
    });
  }, 1500);
  document.addEventListener('click', function(e) {
  var link = e.target.closest('.Product__Gallery a[href*=".webp"]');
  if (link) {
    link.href = link.href.replace('.webp', '.jpg');
  }
}, true);

});

